import React from "react";
import { FormattedMessage } from "react-intl";
import MarkdownPage from "../MarkdownPage";

import koDoc from "./PrivateAndCookie.ko.md";
import enDoc from "./PrivateAndCookie.en.md";

const docs = {
  "ko-KR": koDoc,
  "en-US": enDoc,
};

const PrivateAndCookie = () => (
  <MarkdownPage title={<FormattedMessage id="page_privacy_title" />} docs={docs} />
);

export default PrivateAndCookie;
